import { Navigate, useParams } from "react-router";
import { useEnhancedBiApiClientProvider } from "../../contexts/ApiClientProviderContext";
import { useClientContext } from "../../contexts/ClientContext";
import { useDefineEditReportData } from "../../hooks/useDefineEditReportData";
import RedirectToAdminPortal from "./RedirectToAdminPortal";
import ReportNotFoundOrAccessForbidden from "./ReportNotFoundOrAccessForbidden";
import { getAdminPortalEditReportUrl } from "./getAdminPortalReportUrls";

export const EditRoot = () => {
  const { id } = useParams();
  const { clientCode } = useClientContext();
  const { showReportNotFound } = useDefineEditReportData();
  const { getReportsUrl } = useEnhancedBiApiClientProvider();

  if (id === undefined) {
    return <Navigate to={getReportsUrl(clientCode)} />;
  }

  if (showReportNotFound === true) {
    return <ReportNotFoundOrAccessForbidden getReportsUrl={getReportsUrl} />;
  }
  return <RedirectToAdminPortal url={getAdminPortalEditReportUrl(clientCode, id)} />;
};
